module.exports = __webpack_public_path__ + "assets/d9070af22380a8e1ee8a08815b57252c.png";